import { getToken } from '@/libs/util.token'
export default ({ request }) => ({
  ecomHxPreOrderListApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/list',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/save',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderDelApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/del',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderSubmitApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/submit',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderReviewApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/review',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderRejectApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/reject',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderDetailOptionsApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/detail/options',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderDetailListApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderDetailAddApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/detail/add',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderDetailUpdateApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/detail/update',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderDetailDelApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/detail/del',
      method: 'POST',
      data,
    })
  },
  ecomHxPreOrderFileParseApi(file) {
    const data = new FormData()
    data.append('file', file)

    return request({
      url: '/ecom/hx/pre/order/fileParse',
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || '',
      },
    })
  },
  ecomHxPreOrderImportSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/pre/order/importSave',
      method: 'POST',
      data,
    })
  },
})
